import React from 'react';
import { Box, colors, Stack, styled, Typography, TypographyProps } from '@mui/material';
import dayjs from 'dayjs';

import { InfoTooltip } from '../../../components/core';
import { WebhookEndpoint } from '../types/types';
import appTheme from '../../../styles/themes/theme';

interface Props {
  webhook: WebhookEndpoint;
}

type StyledTypography = React.ComponentType<TypographyProps<'span', { component?: 'span' }>>;
const SectionTitle: StyledTypography = styled(Typography)({
  fontSize: '11px',
  color: colors.grey[600],
  fontWeight: 500,
});

const SectionDescription: StyledTypography = styled(Typography)({
  fontSize: '13px',
  color: 'black',
  overflowWrap: 'anywhere',

  [appTheme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
});

export const WebhookSubscriptionInfo = ({ webhook }: Props) => {
  const { subscriptionId, endpoint, created } = webhook;

  return (
    <Stack spacing={3}>
      <Box>
        <SectionTitle>Endpoint URL</SectionTitle>
        <SectionDescription>{endpoint}</SectionDescription>
      </Box>

      <Box>
        <Stack direction="row" alignItems="center" gap={0.5}>
          <SectionTitle>Subscription ID</SectionTitle>
          <InfoTooltip
            variant="popover"
            popoverWidth={196}
            placement="bottom"
            fontSize={12}
            title="This ID is a unique identifier for this webhook subscription, used exclusively for managing the subscription via the API."
            ariaLabel="Subscription ID details"
          />
        </Stack>
        <SectionDescription>{subscriptionId}</SectionDescription>
      </Box>

      <Box>
        <SectionTitle>Date Created</SectionTitle>
        <SectionDescription>{dayjs(created).format('MM/DD/YY hh:mm A')}</SectionDescription>
      </Box>
    </Stack>
  );
};
